/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// eslint-disable-next-line react/require-default-props
function TextFieldWrapper(props) {
  const {
    id,
    type,
    label,
    placeholder,
    field: { onBlur, onChange, onFocus, value, ...fieldAttrs },
    focused,
    hasError,
    children,
    handleBlur,
    handleFocus,
    handleChange,
    inputRef,
    fieldClass,
    labelClass,
    append,
    readOnly,
    plaintext,
    is,
    disabled,
    note,
    floating = false,
    showRequired,
    ...attrs
  } = props;

  const labelClasses = classNames(
    (placeholder ||
      value ||
      readOnly ||
      plaintext ||
      (focused && !readOnly) ||
      hasError ||
      type === 'date') &&
      'shrink',
    labelClass && labelClass
  );
  const fieldClasses = classNames(fieldClass);

  const onHandleChange = (e) => {
    onChange(e);
    if (handleChange) handleChange(e);
  };

  const onHandleBlur = (e) => {
    onBlur(e);
    if (handleBlur) handleBlur(e);
  };

  const onHandleFocus = (e) => {
    if (onFocus) onFocus(e);
    if (handleFocus) handleFocus(e);
  };

  const inputProps = {
    id,
    as: is || undefined,
    className: fieldClasses,
    readOnly: readOnly || undefined,
    type: type || undefined,
    onBlur: onHandleBlur,
    onFocus: onHandleFocus,
    onChange: onHandleChange,
    placeholder: placeholder || ' ',
    isInvalid: hasError,
    ref: inputRef,
    plaintext: plaintext || undefined,
    value: value === null || value === undefined ? '' : value,
    disabled: disabled,
    ...fieldAttrs,
    ...attrs,
  };

  if (floating) {
    return (
      <div className={`d-flex align-items-center${note ? '' : ' mb-3'}`}>
        <div className="form-floating flex-grow-1">
          <Form.Control {...inputProps} style={readOnly ? { pointerEvents: 'none' } : {}} />
          <Form.Label htmlFor={id} className={labelClasses}>
            {label}
            {showRequired && <span className="text-primary text-lg font-italic"> *</span>}
          </Form.Label>
          {append}
        </div>
        {children}
      </div>
    );
  }
  return (
    <>
      {label && <Form.Label className={labelClasses}>{label}</Form.Label>}
      <Form.Group className="h-100 flex-nowrap">
        <InputGroup>
          <Form.Control {...inputProps} />
          {showRequired && <span className="text-primary text-lg font-italic">{' *'}</span>}
          {append}
        </InputGroup>
      </Form.Group>
      {children}
    </>
  );
}

TextFieldWrapper.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.object.isRequired,
  floating: PropTypes.bool,
};

export default TextFieldWrapper;
